import _ from 'lodash';
/**
 * Concatenates and returns a string of class names.
 *
 * @param classes - The class names to concatenate.
 * @returns A string of concatenated class names.
 */
export function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}
/**
 * Recursively maps the keys of an object or elements of an array using a callback function.
 *
 * @template T - The type of the resulting object or array.
 * @param {Record<string, any>} obj - The object or array to map.
 * @param {(key: string) => string} cb - The callback function that maps the keys or elements.
 * @returns {T} - The resulting object or array with mapped keys or elements.
 */
export const mapKeysDeep = (obj, cb) => {
    if (Array.isArray(obj)) {
        // Handle arrays by recursively mapping their elements
        return obj.map(item => mapKeysDeep(item, cb));
    }
    else if (!_.isObject(obj)) {
        // Return the item if it's not an object
        return obj;
    }
    const result = {};
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const newKey = cb(key);
            result[newKey] = _.isObject(obj[key]) ? mapKeysDeep(obj[key], cb) : obj[key];
        }
    }
    return result;
};
export function logDebug(message) {
    if (process.env.REACT_APP_SHOW_DEBUG_LOGS === 'true') {
        // eslint-disable-next-line no-console
        console.log(`[DEBUG] ${message}`);
    }
}
/**
 * Trims leading and trailing whitespace from specified string fields of an object.
 *
 * @param obj - The object whose fields should be trimmed.
 * @param fields - An array of field names (keys of the object) to trim.
 * @returns A new object with the specified fields trimmed if they are strings.
 */
export function trimObjectStringFields(user, fields) {
    const updated = { ...user };
    fields.forEach(field => {
        if (typeof updated[field] === 'string') {
            updated[field] = updated[field].trim();
        }
    });
    return updated;
}
